import React, { useState } from "react";

const usePagination = () => {
  const [page, setPage] = useState(1);
  const [pages, setPages] = useState(0);
  const [totalCount, setTotalCount] = useState(0);

  const setPagination = (res = {}) => {
    if (page > res?.total_pages) setPage(res?.total_pages);
    setPages(res?.total_pages || 0);
    setTotalCount(res?.total_count);
  };

  return {
    page,
    pages,
    totalCount,
    setPage,
    setPagination,
  };
};

export default usePagination;
